export const config = {
    get base_url() {
        return 'https://service-demo.xfacto.aat.co.za';
        // return 'https://dev7pc11.aat.co.za';
        // return 'http://localhost:33807';
    },
};
//# sourceMappingURL=config.js.map